import { render, staticRenderFns } from "./WhoAmI.vue?vue&type=template&id=03469e14&"
import script from "./WhoAmI.vue?vue&type=script&lang=js&"
export * from "./WhoAmI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports